import {createFileRoute} from '@tanstack/react-router';
import {AuthInstallAgent, AuthPage} from '@/features/auth';
import {authGuard, can} from '@/libs/router';

export const Route = createFileRoute('/_auth/auth/install-ext')({
  beforeLoad: can([authGuard]),
  component: () => (
    <AuthPage>
      <AuthInstallAgent />
    </AuthPage>
  ),
});
